<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-iranmissiles-box">
  <!-- Artboard: xs -->
  <div
    id="g-iranmissiles-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.515625;"
  >
    <div
      id="g-iranmissiles-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/iranmissiles-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:3.9189%;margin-top:-7.1px;left:50.7197%;margin-left:-38px;width:76px;"
    >
      <p class="g-pstyle0">2,000km</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:7.6689%;margin-top:-7.1px;left:50.8243%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle0">1,700km</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:13.2939%;margin-top:-7.1px;left:50.8893%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle0">1,000km</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:25.7939%;margin-top:-7.1px;left:35.3452%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle1">ISRAEL</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.0439%;margin-top:-7.1px;left:58.5667%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.9746%;margin-top:-7px;left:45.559%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle3">18 m</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.9746%;margin-top:-7px;left:93.5443%;margin-left:-21px;width:42px;"
    >
      <p class="g-pstyle3">0 m</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.6569%;margin-top:-7px;right:5.8354%;width:109px;"
    >
      <p class="g-pstyle4"><span class="g-cstyle0">Sejil | </span>2,000 km</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs"
      style="top:56.875%;left:1.5704%;width:32.4242%;"
    >
      <p>
        <span class="g-cstyle1">Iran's arsenal is the largest stockpile</span> of
        ballistic missiles in the Middle East and includes multiple long-range missiles
        that can reach Israel.
      </p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:66.7194%;margin-top:-7px;right:5.7315%;width:114px;"
    >
      <p class="g-pstyle4"><span class="g-cstyle0">Emad | </span>1,700 km</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.0319%;margin-top:-7px;right:5.9527%;width:119px;"
    >
      <p class="g-pstyle4"><span class="g-cstyle0">Ghadr | </span>2,000 km</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.1882%;margin-top:-7px;right:5.9138%;width:135px;"
    >
      <p class="g-pstyle5">
        Shahab-3 | <span class="g-cstyle1">1,300 km</span>
      </p>
    </div>
    <div
      id="g-ai0-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.7194%;margin-top:-7px;right:58.1183%;width:134px;"
    >
      <p class="g-pstyle5">
        Hoveyzeh | <span class="g-cstyle1">1,350 km</span>
      </p>
    </div>
    <div
      id="g-ai0-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.7194%;margin-top:-7px;right:5.7341%;width:157px;"
    >
      <p class="g-pstyle5">
        Khorramshar | <span class="g-cstyle1">2,000 km</span>
      </p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-iranmissiles-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.70833333333333;"
  >
    <div
      id="g-iranmissiles-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/iranmissiles-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:3.9754%;margin-top:-8.6px;left:63.0063%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle0">2,000km</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:8.142%;margin-top:-8.6px;left:63.0088%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle0">1,700km</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:14.5309%;margin-top:-8.6px;left:63.0488%;margin-left:-38.5px;width:77px;"
    >
      <p class="g-pstyle0">1,000km</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:28.4255%;margin-top:-8.7px;left:45.7003%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle1">ISRAEL</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.8144%;margin-top:-8.7px;left:62.2959%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:51.539%;margin-top:-8.1px;left:52.7043%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle3">18 m</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:51.539%;margin-top:-8.1px;left:88.7726%;margin-left:-22.5px;width:45px;"
    >
      <p class="g-pstyle3">0 m</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs"
      style="top:55.9722%;left:1.9911%;width:32.7451%;"
    >
      <p>
        <span class="g-cstyle0">Iran's arsenal is the largest stockpile</span> of
        ballistic missiles in the Middle East and includes multiple long-range missiles
        that can reach Israel.
      </p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:61.4059%;margin-top:-8.1px;right:10.7213%;width:123px;"
    >
      <p class="g-pstyle4"><span class="g-cstyle1">Sejil | </span>2,000 km</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:69.7392%;margin-top:-8.1px;right:10.7998%;width:128px;"
    >
      <p class="g-pstyle4"><span class="g-cstyle1">Emad | </span>1,700 km</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.3226%;margin-top:-8.1px;right:10.7301%;width:135px;"
    >
      <p class="g-pstyle4"><span class="g-cstyle1">Ghadr | </span>2,000 km</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:88.6281%;margin-top:-8.1px;right:10.8096%;width:153px;"
    >
      <p class="g-pstyle5">
        Shahab-3 | <span class="g-cstyle0">1,300 km</span>
      </p>
    </div>
    <div
      id="g-ai1-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:97.3781%;margin-top:-8.1px;right:49.95%;width:152px;"
    >
      <p class="g-pstyle5">
        Hoveyzeh | <span class="g-cstyle0">1,350 km</span>
      </p>
    </div>
    <div
      id="g-ai1-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:97.3781%;margin-top:-8.1px;right:10.7751%;width:178px;"
    >
      <p class="g-pstyle5">
        Khorramshar | <span class="g-cstyle0">2,000 km</span>
      </p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-iranmissiles-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.53488372093023;"
  >
    <div
      id="g-iranmissiles-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/iranmissiles-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:2.3444%;margin-top:-8.1px;left:66.1592%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle0">18 m</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:2.3444%;margin-top:-8.1px;left:94.0301%;margin-left:-22.5px;width:45px;"
    >
      <p class="g-pstyle0">0 m</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:6.6564%;margin-top:-8.6px;left:35.9149%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle1">2,000km</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:13.6332%;margin-top:-8.6px;left:35.9168%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle1">1,700km</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.8657%;margin-top:-8.1px;right:5.5788%;width:123px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle0">Sejil | </span>2,000 km</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:24.3308%;margin-top:-8.6px;left:35.9477%;margin-left:-38.5px;width:77px;"
    >
      <p class="g-pstyle1">1,000km</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.5866%;margin-top:-8.1px;right:5.6395%;width:128px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle0">Emad | </span>1,700 km</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:47.5962%;margin-top:-8.7px;left:22.542%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle3">ISRAEL</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:48.6332%;margin-top:-8.1px;right:5.5856%;width:135px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle0">Ghadr | </span>2,000 km</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:49.9218%;margin-top:-8.7px;left:35.3659%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle4">IRAN</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.4471%;margin-top:-8.1px;right:5.647%;width:153px;"
    >
      <p class="g-pstyle5">
        Shahab-3 | <span class="g-cstyle1">1,300 km</span>
      </p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.9355%;margin-top:-8.1px;right:5.6204%;width:178px;"
    >
      <p class="g-pstyle5">
        Khorramshar | <span class="g-cstyle1">2,000 km</span>
      </p>
    </div>
    <div
      id="g-ai2-13"
      class="g-text g-aiAbs"
      style="top:85.5814%;left:0.6785%;width:62.4242%;"
    >
      <p>
        <span class="g-cstyle1">Iran's arsenal is the largest stockpile</span> of
        ballistic missiles in the Middle East and includes multiple long-range missiles
        that can reach Israel.
      </p>
    </div>
    <div
      id="g-ai2-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.6099%;margin-top:-8.1px;right:5.5349%;width:152px;"
    >
      <p class="g-pstyle5">
        Hoveyzeh | <span class="g-cstyle1">1,350 km</span>
      </p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-iranmissiles-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.9375;"
  >
    <div
      id="g-iranmissiles-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/iranmissiles-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:1.9961%;margin-top:-9.6px;left:62.4105%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle0">18 m</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:1.9961%;margin-top:-9.6px;left:84.9019%;margin-left:-22.5px;width:45px;"
    >
      <p class="g-pstyle0">0 m</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:14.088%;margin-top:-8.6px;left:34.5654%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle1">2,000km</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.463%;margin-top:-9.6px;right:14.7902%;width:123px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle0">Sejil | </span>2,000 km</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:20.338%;margin-top:-8.6px;left:34.5667%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle1">1,700km</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:29.9214%;margin-top:-8.6px;left:34.5887%;margin-left:-38.5px;width:77px;"
    >
      <p class="g-pstyle1">1,000km</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.213%;margin-top:-9.6px;right:14.8332%;width:128px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle0">Emad | </span>1,700 km</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:48.2547%;margin-top:-9.6px;right:14.795%;width:135px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle0">Ghadr | </span>2,000 km</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.9716%;margin-top:-8.7px;left:27.6556%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle3">ISRAEL</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.055%;margin-top:-8.7px;left:38.0468%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle4">IRAN</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.8797%;margin-top:-9.6px;right:14.8386%;width:153px;"
    >
      <p class="g-pstyle5">
        Shahab-3 | <span class="g-cstyle1">1,300 km</span>
      </p>
    </div>
    <div
      id="g-ai3-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.4214%;margin-top:-9.6px;right:14.8197%;width:178px;"
    >
      <p class="g-pstyle5">
        Khorramshar | <span class="g-cstyle1">2,000 km</span>
      </p>
    </div>
    <div
      id="g-ai3-13"
      class="g-text g-aiAbs"
      style="top:84.7917%;left:2.6407%;width:44.3011%;"
    >
      <p>
        <span class="g-cstyle1">Iran's arsenal is the largest stockpile</span> of
        ballistic missiles in the Middle East and includes multiple long-range missiles
        that can reach Israel.
      </p>
    </div>
    <div
      id="g-ai3-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.1297%;margin-top:-9.6px;right:14.759%;width:152px;"
    >
      <p class="g-pstyle5">
        Hoveyzeh | <span class="g-cstyle1">1,350 km</span>
      </p>
    </div>
  </div>
</div>
<!-- End ai2html - 2025-06-17 12:39 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-17 12:39 -->
<!-- ai file: iranmissiles.ai -->
<style lang="scss">
  #g-iranmissiles-box,
  #g-iranmissiles-box .g-artboard {
    margin: 0 auto;
  }
  #g-iranmissiles-box p {
    margin: 0;
  }
  #g-iranmissiles-box .g-aiAbs {
    position: absolute;
  }
  #g-iranmissiles-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-iranmissiles-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-iranmissiles-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-iranmissiles-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-iranmissiles-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-iranmissiles-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-iranmissiles-lg {
        display: block !important;
      }
    }
  }
  #g-iranmissiles-xs {
    position: relative;
    overflow: hidden;
  }
  #g-iranmissiles-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-iranmissiles-xs .g-pstyle0 {
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-iranmissiles-xs .g-pstyle1 {
    font-weight: 700;
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    text-align: center;
    color: rgb(165, 15, 21);
  }
  #g-iranmissiles-xs .g-pstyle2 {
    font-weight: 700;
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-iranmissiles-xs .g-pstyle3 {
    line-height: 13px;
    height: 13px;
    padding-bottom: 7px;
    font-size: 12px;
    text-align: center;
    color: rgb(185, 185, 185);
  }
  #g-iranmissiles-xs .g-pstyle4 {
    font-weight: 700;
    line-height: 13px;
    height: 13px;
    font-size: 13px;
    text-align: right;
  }
  #g-iranmissiles-xs .g-pstyle5 {
    line-height: 13px;
    height: 13px;
    font-size: 13px;
    text-align: right;
  }
  #g-iranmissiles-xs .g-cstyle0 {
    font-weight: 400;
  }
  #g-iranmissiles-xs .g-cstyle1 {
    font-weight: 700;
  }
  #g-iranmissiles-sm {
    position: relative;
    overflow: hidden;
  }
  #g-iranmissiles-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-iranmissiles-sm .g-pstyle0 {
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-iranmissiles-sm .g-pstyle1 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    text-align: center;
    color: rgb(165, 15, 21);
  }
  #g-iranmissiles-sm .g-pstyle2 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-iranmissiles-sm .g-pstyle3 {
    line-height: 15px;
    height: 15px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(185, 185, 185);
  }
  #g-iranmissiles-sm .g-pstyle4 {
    font-weight: 700;
    line-height: 15px;
    height: 15px;
    font-size: 15px;
    text-align: right;
  }
  #g-iranmissiles-sm .g-pstyle5 {
    line-height: 15px;
    height: 15px;
    font-size: 15px;
    text-align: right;
  }
  #g-iranmissiles-sm .g-cstyle0 {
    font-weight: 700;
  }
  #g-iranmissiles-sm .g-cstyle1 {
    font-weight: 400;
  }
  #g-iranmissiles-md {
    position: relative;
    overflow: hidden;
  }
  #g-iranmissiles-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-iranmissiles-md .g-pstyle0 {
    line-height: 15px;
    height: 15px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(185, 185, 185);
  }
  #g-iranmissiles-md .g-pstyle1 {
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-iranmissiles-md .g-pstyle2 {
    font-weight: 700;
    line-height: 15px;
    height: 15px;
    font-size: 15px;
    text-align: right;
  }
  #g-iranmissiles-md .g-pstyle3 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    text-align: center;
    color: rgb(165, 15, 21);
  }
  #g-iranmissiles-md .g-pstyle4 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-iranmissiles-md .g-pstyle5 {
    line-height: 15px;
    height: 15px;
    font-size: 15px;
    text-align: right;
  }
  #g-iranmissiles-md .g-cstyle0 {
    font-weight: 400;
  }
  #g-iranmissiles-md .g-cstyle1 {
    font-weight: 700;
  }
  #g-iranmissiles-lg {
    position: relative;
    overflow: hidden;
  }
  #g-iranmissiles-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-iranmissiles-lg .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    color: rgb(185, 185, 185);
  }
  #g-iranmissiles-lg .g-pstyle1 {
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    text-align: center;
  }
  #g-iranmissiles-lg .g-pstyle2 {
    font-weight: 700;
    height: 18px;
    font-size: 15px;
    text-align: right;
  }
  #g-iranmissiles-lg .g-pstyle3 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    text-align: center;
    color: rgb(165, 15, 21);
  }
  #g-iranmissiles-lg .g-pstyle4 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-iranmissiles-lg .g-pstyle5 {
    height: 18px;
    font-size: 15px;
    text-align: right;
  }
  #g-iranmissiles-lg .g-cstyle0 {
    font-weight: 400;
  }
  #g-iranmissiles-lg .g-cstyle1 {
    font-weight: 700;
  }

  /* Custom CSS */
  .g-whiteshadow {
    text-shadow:
      #ffffff 1px 0px 0px,
      #ffffff 0.540302px 0.841471px 0px,
      #ffffff -0.416147px 0.909297px 0px,
      #ffffff -0.989992px 0.14112px 0px,
      #ffffff -0.653644px -0.756802px 0px,
      #ffffff 0.283662px -0.958924px 0px,
      #ffffff 0.96017px -0.279415px 0px;
  }
</style>
